import React, { useState } from 'react'
import { Input } from 'front-end/src/components'
import { InputProps } from '@chakra-ui/react'
import { useDebouncedCallback } from 'use-debounce'

const DEFAULT_DEBOUNCE = 500

export const InputWithState = ({
  dataTest = 'Input',
  debounce,
  value: propsValue,
  defaultValue,
  onChange,
  ...rest
}: InputProps & { debounce?: number; dataTest?: string }) => {
  const [value, setValue] = useState(propsValue || defaultValue || '')

  const debounced = useDebouncedCallback((e) => {
    onChange && onChange(e)
  }, debounce || DEFAULT_DEBOUNCE)

  return (
    <Input
      {...rest}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value
        setValue(newValue)
        if (debounce) {
          debounced(e)
        } else {
          onChange && onChange(e)
        }
      }}
      data-test={dataTest}
    />
  )
}
